const types = {
    ADD_CART: 'ADD_CART',
    DELETE_CART: 'DELETE_CART',
    DELETE_PRODUCT:'DELETE_PRODUCT',
  }

 export default types;
